import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "base-form" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", null, "Группы сервисных работ", -1)
const _hoisted_3 = { class: "base-form" }
const _hoisted_4 = { class: "base-form" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 18 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _hoisted_2,
              _createVNode(_component_el_button, {
                type: "primary",
                icon: _ctx.circleIcon,
                size: "large",
                onClick: _ctx.onAddCategoryClick
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Новая группа ")
                ]),
                _: 1
              }, 8, ["icon", "onClick"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_el_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 24 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.tableSearchQuery,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tableSearchQuery) = $event)),
                style: {"max-width":"600px"},
                clearable: "",
                placeholder: "Поиск по названию группы сервисных работ",
                class: "input-with-select"
              }, {
                append: _withCtx(() => [
                  _createVNode(_component_el_button, { icon: _ctx.searchIcon }, null, 8, ["icon"])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 24 }, {
          default: _withCtx(() => [
            _withDirectives((_openBlock(), _createBlock(_component_el_table, {
              "row-key": "id",
              sortable: "custom",
              data: _ctx.tableData,
              "default-sort": { prop: _ctx.tableSortColumn, order: _ctx.tableSortOrder },
              onSortChange: _ctx.onTableSortingChange,
              onRowClick: _ctx.onTableRowClick
            }, {
              empty: _withCtx(() => [
                _createTextVNode(" Список групп пуст, попробуйте изменить фильтр ")
              ]),
              default: _withCtx(() => [
                (!_ctx.isPickerMode)
                  ? (_openBlock(), _createBlock(_component_el_table_column, {
                      key: 0,
                      type: "selection"
                    }))
                  : _createCommentVNode("", true),
                (_ctx.isPickerMode)
                  ? (_openBlock(), _createBlock(_component_el_table_column, {
                      key: 1,
                      width: "100"
                    }, {
                      default: _withCtx((scope) => [
                        _createVNode(_component_el_button, {
                          size: "small",
                          type: "primary",
                          onClick: (e) => _ctx.onPickJobCategoryClick(scope.row, e)
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Выбрать ")
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_table_column, {
                  label: "Категория",
                  prop: "name",
                  sortable: "",
                  "column-key": "name"
                }),
                _createVNode(_component_el_table_column, {
                  label: "Описание",
                  prop: "description",
                  "column-key": "description"
                }),
                (!_ctx.isPickerMode)
                  ? (_openBlock(), _createBlock(_component_el_table_column, {
                      key: 2,
                      align: "right"
                    }, {
                      default: _withCtx((scope) => [
                        _createVNode(_component_el_button, {
                          size: "small",
                          type: "danger",
                          onClick: (e) => _ctx.onDeleteJobGroupClick(scope.row.id, scope.row.name, e)
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Удалить ")
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["data", "default-sort", "onSortChange", "onRowClick"])), [
              [_directive_loading, _ctx.tableLoading]
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (_ctx.isPickerMode)
      ? (_openBlock(), _createBlock(_component_el_row, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_el_button, { onClick: _ctx.onCloseCurrentTabClick }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Отмена ")
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}